import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    updateProfile: build.mutation({
      query: (data) => ({
        url: `${apiUrl.updateProfile}`,
        method: 'POST',
        body: data,
      })
    }),
  }),
  overrideExisting: false,
});
export const {
  useUpdateProfileMutation
} = extendedApi;
